export enum Environment {
  Prod = 'prod',
  TacticProd = 'tactic-prod',
  Staging = 'staging',
  TacticStage = 'tactic-stage',
  Local = 'local',
  Zeus = 'zeus',
  Other = 'other',
}

const isZeusBuild = () => import.meta.env.MODE === Environment.Zeus

export const getEnvironment = () => {
  if (isZeusBuild()) {
    return Environment.Zeus
  }

  switch (window.location.host.split(':', 1)[0]) {
    case 'app.choosetactic.com': {
      return Environment.TacticProd
    }
    case 'accounting.taxbit.com': {
      return Environment.Prod
    }
    case 'stage.choosetactic.com': {
      return Environment.TacticStage
    }
    case 'stage.accounting.taxbit.com': {
      return Environment.Staging
    }
    case 'localhost': {
      return import.meta.env.VITE_ENVIRONMENT === 'staging'
        ? Environment.Staging
        : Environment.Local
    }
    default: {
      return Environment.Other
    }
  }
}

export const isProdEnvironment = () =>
  getEnvironment() === Environment.Prod || getEnvironment() === Environment.TacticProd
export const isStagingEnvironment = () =>
  getEnvironment() === Environment.Staging || getEnvironment() === Environment.TacticStage
export const isDevEnvironment = () => getEnvironment() === Environment.Local
export const isZeusEnvironment = () => getEnvironment() === Environment.Zeus
